import React from 'react';

export default function CustomCheckbox({
  id,
  name,
  label,
  checked,
  onChange,
  className = ''
}) {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative flex items-center">

        <input
          id={id}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />


        <div
          className="w-5 h-5 flex items-center justify-center cursor-pointer border-2 border-[#818181] rounded-md bg-[#1E1E1E] bg-opacity-70"
          onClick={() => onChange(!checked)}
          aria-hidden="true"
        >
          {checked && (
            <div className="w-3 h-3 bg-[#818181] rounded-[1px]"></div>
          )}
        </div>
      </div>

      {label && (
        <label
          htmlFor={id}
          className="ml-2 font-public-sans text-[#8D8D8D] text-[1.125rem] font-normal leading-none tracking-normal cursor-pointer"
        >
          {label}
        </label>
      )}
    </div>
  );
}